import {
  Component,
  inject,
  Injector,
  OnDestroy,
  runInInjectionContext,
} from '@angular/core';
import { AuthService } from '@sia/auth';
import {
  retriveCurrentRouteData,
  SiaBaseActionService,
  SiaI18nService,
  SiaNewRouterService,
  SiaRouteData,
  SiaSizeDetectorService,
  SiaUsersService,
  SiaUtilsService,
  SiaWindowSize,
} from '@sia/shared';
import { Subscription } from 'rxjs';
import { SiaGridComponent } from '../../components/sia-grid/sia-grid.component';

@Component({
  selector: 'sia-grid-page',
  templateUrl: './sia-grid-page.component.html',
  styleUrls: ['./sia-grid-page.component.scss'],
  standalone: true,
  imports: [SiaGridComponent],
})
export class SiaGridPageComponent implements OnDestroy {
  private authService = inject(AuthService);
  private utilsService = inject(SiaUtilsService);
  private userService = inject(SiaUsersService);
  private actionsService = inject(SiaBaseActionService);
  private i18nService = inject(SiaI18nService);
  private sizeDetector = inject(SiaSizeDetectorService);
  private siaRouterService = inject(SiaNewRouterService);
  private injector: Injector = inject(Injector);

  windowSize: SiaWindowSize = {};
  private _subs: Subscription[] = [];
  pageData?: SiaRouteData;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    let s0 = this.sizeDetector.onResize$.subscribe(
      (size: SiaWindowSize | null) => {
        if (!size) {
          return;
        }
        this.windowSize = size;
      },
    );
    this._subs.push(s0);
    let s1 = this.siaRouterService.routeChanged$.subscribe(() => {
      var pageData: any = null;
      runInInjectionContext(this.injector, () => {
        pageData = retriveCurrentRouteData() ?? {};
      });
      if (!pageData?.guid || pageData?.guid == this.pageData?.guid) {
        return;
      }
      this.pageData = pageData!;
    });
    this._subs.push(s1);
  }
  ngOnDestroy(): void {
    this._subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  //#region private methods
  private manageImpersonate(params: string[]) {
    if (!params) return;
    if (params.length != 1) return;
    var strPar = params[0];
    var splitted = strPar.split('=');
    if (splitted && splitted.length == 2) {
      if (splitted[0] == 'id') {
        let id = splitted[1];
        this.authService.impersonate(+id).catch((e: any) => {
          this.utilsService.notifyErrorOnException(e, 'sia-grid-page');
        });
      }
    }
  }
  //#endregion

  //#region public methods

  async onGridSaved(gridId: string) {
    if (gridId === 'translations') {
      await this.i18nService.updateSessionTranslations();
    }
  }

  onGridAction(event: any) {
    if (event) {
      if (event.actionId === 'impersonate') {
        this.manageImpersonate(event.params);
      }
    }
  }
  //#endregion
}
